<script lang="ts">
  import type { Correction } from '$lib/types/grammar'
  
  interface Props {
    corrections?: Correction[]
    suggestions?: string[]
    onApplyCorrection: (correction: Correction) => void
  }
  
  let { corrections, suggestions, onApplyCorrection }: Props = $props()
</script>

<div class="suggestions-inline">
  {#if corrections && corrections.length > 0}
    {#each corrections as correction}
      <button
        class="suggestion-inline"
        onclick={() => onApplyCorrection(correction)}
      >
        {correction.text}
      </button>
    {/each}
  {:else if suggestions && suggestions.length > 0}
    {#each suggestions as suggestion, idx}
      <button
        class="suggestion-inline"
        onclick={() => onApplyCorrection({ id: `suggestion-${idx}`, text: suggestion })}
      >
        {suggestion}
      </button>
    {/each}
  {/if}
</div>

<style>
  /* Suggestions container */
  .suggestions-inline {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
    align-items: center;
  }
  
  /* Suggestion buttons */
  .suggestion-inline {
    background: var(--bg-secondary);
    border: 1px solid var(--border-primary);
    border-radius: 4px;
    padding: 2px 6px;
    font-size: 12px;
    color: var(--text-primary);
    cursor: pointer;
    transition: all 0.15s ease;
    white-space: nowrap;
    line-height: 1.3;
  }
  
  .suggestion-inline:hover {
    background: var(--bg-tertiary);
    border-color: var(--border-secondary);
    color: var(--text-primary);
  }
  
  /* Mobile optimizations */
  @media (max-width: 768px) {
    .suggestion-inline {
      font-size: 13px;
      padding: 4px 8px;
      min-height: 32px;
    }
  }
  
  /* Dark mode support - colors already handled by CSS variables */
  
  /* Reduced motion */
  @media (prefers-reduced-motion: reduce) {
    .suggestion-inline {
      transition: none;
    }
  }
</style>